@if (firstMessage() && !dismissed()) {
  <div
    class="screen-message"
    [class]="severityClass(firstMessage()?.severity)"
    role="alert"
  >
    <span class="screen-message__icon" aria-hidden="true">!</span>
    <div class="screen-message__body">
      @if (expanded()) {
        <span class="screen-message__text">{{ firstMessage()!.text }}</span>
      } @else {
        <span class="screen-message__text">{{
          truncate(firstMessage()!.text)
        }}</span>
      }
      @if (firstMessage()!.text.length > 80) {
        <button
          type="button"
          class="screen-message__expand"
          (click)="toggleExpand()"
        >
          {{ expanded() ? '閉じる' : '詳細' }}
        </button>
      }
      @if (restCount() > 0) {
        <span class="screen-message__rest">他{{ restCount() }}件</span>
      }
    </div>
    <button
      type="button"
      class="screen-message__close"
      (click)="dismiss()"
      aria-label="閉じる"
    >
      ×
    </button>
  </div>
}
